import { Link } from "@tanstack/react-router";
import { Lightbulb } from "lucide-react";
import type * as React from "react";
import {
  EntityCardContent,
  EntityCardsGrid,
  entityCardClass,
} from "@/components/shared/entity-cards";
import { LifecycleBadge } from "@/components/shared/lifecycle-badge";
import type { Competency } from "@/hooks/use-competencies";
import { carryListSearch } from "@/lib/list-search";

interface CompetencyCardsProps {
  competencies: Competency[];
  loading?: boolean;
  empty: React.ReactNode;
}

export function CompetencyCards({ competencies, loading, empty }: CompetencyCardsProps) {
  return (
    <EntityCardsGrid loading={loading} isEmpty={competencies.length === 0} empty={empty}>
      {competencies.map((competency) => (
        <Link
          key={competency.id}
          to="/dashboard/competencies/$competencyId"
          params={{ competencyId: competency.id }}
          search={carryListSearch()}
          aria-label={`Open ${competency.name}`}
          className={entityCardClass(true)}
        >
          <EntityCardContent
            icon={Lightbulb}
            title={competency.name}
            subtitle={
              competency.roles.length > 0
                ? competency.roles.map((r) => r.name).join(", ")
                : "No roles"
            }
            trailing={<LifecycleBadge status={competency.status} />}
          />
        </Link>
      ))}
    </EntityCardsGrid>
  );
}
